import apiClient from "api/apiClient";

export const getPartidos = () => apiClient.get("partidos");
